<script>
    // import { localize } from "#runtime/util/i18n";

    import ItemInformation from "./ItemInformation.svelte";

    let currentSelected = "melee";

</script>

<ItemInformation {currentSelected}/>

<style lang="scss">

</style>
